var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFbRounded = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    alt: "facebook",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_fb",
    transform: "translate(-2781 -6109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Group_29",
    "data-name": "Group 29",
    d: "M16.781,10.744a5.781,5.781,0,1,0-6.69,5.705V12.421H8.622V10.744h1.469V9.486a2.046,2.046,0,0,1,2.168-2.259,8.521,8.521,0,0,1,1.305.116V8.765h-.723a.844.844,0,0,0-.956.908v1.071h1.608l-.256,1.677H11.886v4.029A5.77,5.77,0,0,0,16.781,10.744Z",
    transform: "translate(2777.781 6106.031)",
    fill: "rgba(102,102,102,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 16,
    height: 16,
    transform: "translate(2781 6109)",
    fill: "none"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFbRounded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fb_rounded.3a56abfe.svg";
export { ForwardRef as ReactComponent };